export default [
  {
    path: '/2022/report/doc',
    component: () => import('./views/report/doc')
  },
  {
    path: '/2022/report/login',
    component: () => import('./views/report/login.vue')
  }
]



// WEBPACK FOOTER //
// ./src/page/2022/route.js